import {
    FETCH_STATE,
    LoaderWithText,
    RefreshWithErrorText,
} from '../../../common/PatientOverviewUtils';

const PastVisitEmptyCard: React.FC<{ fetchState?: FETCH_STATE; onRefresh?: () => void }> = ({
    fetchState,
    onRefresh,
}) => {
    return (
        <div className="flex flex-col rounded-8 font-lato bg-white w-full h-full pb-16 relative">
            <div className="pb-20 flex-1 grid place-content-center text-14">
                <div className="w-200 h-162 overflow-hidden m-auto">
                    <img src="/images/Prescription.png" alt="prescription" />s
                </div>
                <p className="font-700 text-center mt-20 mb-12 h-24">
                    {fetchState === FETCH_STATE.FETCHING ? (
                        <LoaderWithText text="Fetching prescriptions" />
                    ) : fetchState === FETCH_STATE.ERROR ? (
                        <RefreshWithErrorText
                            text="Error in Fetching prescriptions"
                            onRefresh={onRefresh}
                        />
                    ) : (
                        'No prescription created!'
                    )}
                </p>
                <p className="text-center max-w-304 text-darwin-neutral-600">
                    Whenever the patient visits you next again, you will see your last prescription
                    here
                </p>
            </div>
        </div>
    );
};

export default PastVisitEmptyCard;
